export default [
  {
    key: 'increasement',
    label: '#',
    thClass: 'w-50px',
  },
  {
    key: 'name',
    label: 'field.name',
    stickyColumn: true,
    variant: 'light',
  },
  {
    key: 'username',
    label: 'field.username',
  },
  {
    key: 'givenCredit',
    label: 'field.givenCredit',
    tdClass: 'text-right',
  },
  {
    key: 'avalBalance',
    label: 'field.avaliableCredit',
    tdClass: 'text-right text-positive',
  },
  // {
  //   key: 'cashBalance',
  //   sortable: false,
  //   sortField: '',
  //   label: 'field.cashBalance',
  //   tdClass: 'text-right',
  // },
  {
    key: 'member',
    label: 'field.member',
  },
  {
    key: 'ipaddress',
    label: 'field.ipAddress',
  },
  {
    key: 'lastActivityAt',
    label: 'field.lastActiveDate',
  },
  {
    key: 'status',
    label: 'field.status',
  },
  {
    key: 'createdAt',
    sortField: 'person.createdAt',
    label: 'field.createDate',
  },
  {
    key: 'actions',
    label: 'general.action',
  },
];
